export default __webpack_public_path__ + "static/media/c001-general2024-7.112842c7.png";